import axiosInstance from "@/service/axiosInstance";
import Link from "next/link";
import React, { useEffect, useState } from "react";

const ContactArea = () => {
  const [cityData, setCityData] = useState<any>([]);
  const [cityWRTSchoolData, setCityWRTSchoolData] = useState([]);
  const [activeCity, setActiveCity] = useState(null);
  const [uniqueCities, setUniqueCities] = useState(new Set());
  // const [selectedCity, setSelectedCity] = useState(null);
  const [filterdData, setFilteredData] = useState([]);

  const setCitydata = (city: any, data: any) => {
    console.log("🚀 ~ setCitydata ~ data:", data);
    console.log("🚀 ~ setCitydata ~ city:", city);

    const filteredData = data?.filter(
      (item: any) => item?.attributes?.City?.data?.attributes?.name === city,
    );

    const groupedData: any = Object.values(
      filteredData.reduce((acc: any, item: any) => {
        const attrs = item.attributes;
        const address = attrs.Address;

        if (!acc[address]) {
          acc[address] = {
            ...item,
            attributes: {
              ...attrs,
              Phone_No_1: [],
              Phone_No_2: [],
              Email_ID: [],
            },
          };
        }

        // Add unique Phone_No_1
        if (
          attrs.Phone_No_1 &&
          !acc[address].attributes.Phone_No_1.includes(attrs.Phone_No_1)
        ) {
          acc[address].attributes.Phone_No_1.push(attrs.Phone_No_1);
        }

        // Add unique Phone_No_2
        if (
          attrs.Phone_No_2 &&
          !acc[address].attributes.Phone_No_2.includes(attrs.Phone_No_2)
        ) {
          acc[address].attributes.Phone_No_2.push(attrs.Phone_No_2);
        }

        // Add unique Email_ID
        if (
          attrs.Email_ID &&
          !acc[address].attributes.Email_ID.includes(attrs.Email_ID)
        ) {
          acc[address].attributes.Email_ID.push(attrs.Email_ID);
        }

        return acc;
      }, {}),
    );

    setFilteredData(groupedData);
    console.log("🚀 ~ groupedData:", groupedData);
  };
  const getData = async () => {
    const response = await axiosInstance.get("/contact-us", {});
    const cities = new Set();
    response?.data?.forEach((item: any) => {
      const cityName = item.attributes.City.data?.attributes.name;
      cities.add(cityName);
    });
    setCityData(response.data);
    // console.log("🚀 ~ getData ~ response.data:", response.data);
    setUniqueCities(cities);
    // setSelectedCity(cities.values().next().value);
    // setFilteredData()
    setActiveCity(response?.data[0]?.attributes.City.data?.attributes.name);
    setCitydata(cities.values().next().value, response?.data);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleCityClick = (city: any) => {
    setCitydata(city, cityData);
    setActiveCity(city);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            width: "90%",
          }}
        >
          {Array.from(uniqueCities).map((location: any, index) => (
            <>
              <div
                style={{
                  marginTop: "20px",
                  marginLeft: "1.5rem",
                  marginRight: "1.5rem",
                  marginBottom: "20px",
                  display: "flex",
                  boxSizing: "border-box",

                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontFamily: "Graphik,sans-serif",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    padding: "10px 24px",
                    height: "2.25rem",
                    borderRadius: "100px",
                    borderStyle: "solid",
                    borderColor:
                      activeCity === location ? "#3F41D1" : "#A3A3A3",
                    display: "flex",
                    alignItems: "center",
                    border:
                      activeCity === location
                        ? "1px solid #3F41D1"
                        : "1px solid #A3A3A3",
                    color: activeCity === location ? "#3F41D1" : "#666",
                    backgroundColor:
                      activeCity === location ? "#E1E8F5" : "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleCityClick(location);
                    setActiveCity(location);
                  }}
                  onMouseEnter={(e: any) => {
                    e.target.style.borderRadius = "100px";
                    e.target.style.border = "1px solid #3F41D1";
                    e.target.style.backgroundColor = "#E1E8F5";
                    e.target.style.color = "#3F41D1";
                  }}
                  onMouseLeave={(e: any) => {
                    if (activeCity !== location) {
                      e.target.style.borderRadius = "100px";
                      e.target.style.border = "1px solid #A3A3A3";
                      e.target.style.backgroundColor = "#FFF";
                      e.target.style.color = "#666";
                    }
                  }}
                >
                  {location}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1.375rem",
          maxWidth: "90%",
          margin: "0 auto",
          justifyContent: "center", // optional
          alignItems: "stretch", // makes items stretch to same height
        }}
      >
        {filterdData?.map((data: any, index) => (
          <>
            <div
              style={{
                marginBottom: "50px",
              }}
            >
              <div
                style={{
                  borderRadius: "10px",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  fontFamily: "Graphik,sans-serif",
                  borderColor: "#3F41D1",
                  display: "flex",
                  color: "#3F41D1",
                  flexDirection: "column",
                  backgroundColor: "white",
                  maxWidth: "23.68rem",
                  minHeight: "17.75rem",
                  height: "100%",
                  border: "2px solid var(--S2-Primary, #7B7FDE)",
                  // overflow: "hidden",
                  padding: "1.5rem",
                }}
              >
                <h1
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "500",
                    color: " var(--Text, #212121)",
                    textTransform: "capitalize",
                  }}
                >
                  {data?.attributes?.City?.data?.attributes?.name
                    ? data?.attributes?.City?.data?.attributes?.name
                    : ""}
                </h1>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.125rem",
                  }}
                >
                  <Link
                    href={`https://maps.google.com?q=${data?.attributes?.Latitude},${data?.attributes?.Longitude}`}
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        gap: "0.5rem",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M9.00016 10.0725C10.2925 10.0725 11.3402 9.02486 11.3402 7.73252C11.3402 6.44017 10.2925 5.39252 9.00016 5.39252C7.70781 5.39252 6.66016 6.44017 6.66016 7.73252C6.66016 9.02486 7.70781 10.0725 9.00016 10.0725Z"
                            stroke="#666666"
                            stroke-width="1.5"
                          />
                          <path
                            d="M2.71527 6.3675C4.19277 -0.127498 13.8153 -0.119998 15.2853 6.375C16.1478 10.185 13.7778 13.41 11.7003 15.405C10.1928 16.86 7.80777 16.86 6.29277 15.405C4.22277 13.41 1.85277 10.1775 2.71527 6.3675Z"
                            stroke="#666666"
                            stroke-width="1.5"
                          />
                        </svg>
                      </div>
                      <div style={{ color: "var(--Text-2, #666)" }}>
                        {data?.attributes?.Address}
                      </div>
                    </div>
                  </Link>
                  {/* <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      gap: "0.5rem",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M2.76358 0.999878C4.01634 0.999878 5.03965 2.08887 5.03965 3.42157V14.5782C5.03965 15.9111 4.01634 16.9999 2.76358 16.9999C1.51081 16.9999 0.487305 15.9111 0.487305 14.5782V3.42157C0.487305 2.08887 1.51081 0.999878 2.76358 0.999878ZM8.48131 12.3202C8.80663 12.3202 9.07048 12.6007 9.07048 12.9471C9.07048 13.2932 8.80663 13.5739 8.48131 13.5739C8.1558 13.5739 7.89214 13.2932 7.89214 12.9471C7.89214 12.6007 8.1558 12.3202 8.48131 12.3202ZM13.7842 12.3202C14.1096 12.3202 14.3734 12.6007 14.3734 12.9471C14.3734 13.2932 14.1096 13.5739 13.7842 13.5739C13.4589 13.5739 13.1951 13.2932 13.1951 12.9471C13.1951 12.6007 13.4589 12.3202 13.7842 12.3202ZM11.1328 12.3202C11.4581 12.3202 11.7219 12.6007 11.7219 12.9471C11.7219 13.2932 11.4581 13.5739 11.1328 13.5739C10.8073 13.5739 10.5436 13.2932 10.5436 12.9471C10.5436 12.6007 10.8073 12.3202 11.1328 12.3202ZM8.48131 7.55211C8.80663 7.55211 9.07048 7.83284 9.07048 8.17897C9.07048 8.52531 8.80663 8.80583 8.48131 8.80583C8.1558 8.80583 7.89214 8.52531 7.89214 8.17897C7.89214 7.83284 8.1558 7.55211 8.48131 7.55211ZM13.7842 7.55211C14.1096 7.55211 14.3734 7.83284 14.3734 8.17897C14.3734 8.52531 14.1096 8.80583 13.7842 8.80583C13.4589 8.80583 13.1951 8.52531 13.1951 8.17897C13.1951 7.83284 13.4589 7.55211 13.7842 7.55211ZM11.1328 7.55211C11.4581 7.55211 11.7219 7.83284 11.7219 8.17897C11.7219 8.52531 11.4581 8.80583 11.1328 8.80583C10.8073 8.80583 10.5436 8.52531 10.5436 8.17897C10.5436 7.83284 10.8073 7.55211 11.1328 7.55211ZM8.48131 9.93616C8.80663 9.93616 9.07048 10.2167 9.07048 10.563C9.07048 10.9092 8.80663 11.1899 8.48131 11.1899C8.1558 11.1899 7.89214 10.9092 7.89214 10.563C7.89214 10.2167 8.1558 9.93616 8.48131 9.93616ZM13.7842 9.93616C14.1096 9.93616 14.3734 10.2167 14.3734 10.563C14.3734 10.9092 14.1096 11.1899 13.7842 11.1899C13.4589 11.1899 13.1951 10.9092 13.1951 10.563C13.1951 10.2167 13.4589 9.93616 13.7842 9.93616ZM11.1328 9.93616C11.4581 9.93616 11.7219 10.2167 11.7219 10.563C11.7219 10.9092 11.4581 11.1899 11.1328 11.1899C10.8073 11.1899 10.5436 10.9092 10.5436 10.563C10.5436 10.2167 10.8073 9.93616 11.1328 9.93616ZM8.15058 4.0001H14.115C14.3359 4.0001 14.5151 4.19095 14.5151 4.42603V6.42199C14.5151 6.65706 14.3359 6.84771 14.115 6.84771H8.15058C7.92964 6.84771 7.75045 6.65706 7.75045 6.42199V4.42603C7.75045 4.19095 7.92964 4.0001 8.15058 4.0001ZM13.7146 4.85195H8.5509V5.99606H13.7146V4.85195ZM15.6869 2.82391H6.57869V15.1758H15.6869V2.82391ZM6.17856 1.97225H16.087C16.3081 1.97225 16.4873 2.16311 16.4873 2.39818V15.6018C16.4873 15.8369 16.3081 16.0275 16.087 16.0275H6.17856C5.95743 16.0275 5.77824 15.8369 5.77824 15.6018V2.39818C5.77824 2.16311 5.95743 1.97225 6.17856 1.97225ZM2.76358 1.85174C1.95269 1.85174 1.28794 2.55901 1.28794 3.42157V14.5782C1.28794 15.4409 1.95269 16.1482 2.76358 16.1482C3.57426 16.1482 4.23921 15.4409 4.23921 14.5782V3.42157C4.23921 2.55901 3.57426 1.85174 2.76358 1.85174Z"
                          fill="#212121"
                        />
                      </svg>
                    </div>
                    <div style={{ color: "var(--Text-2, #666)" }}>
                      {data?.attributes?.Tollfree_No}
                    </div>
                  </div> */}
                  {data?.attributes?.Phone_No_1.length > 0 &&
                    data?.attributes?.Phone_No_1.map((phone: any) => (
                      <>
                        <Link
                          href={`tel:${phone}`}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              gap: "0.5rem",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z"
                                  stroke="#666666"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                />
                              </svg>
                            </div>
                            <div style={{ color: "var(--Text-2, #666)" }}>
                              {phone}
                            </div>
                          </div>
                        </Link>
                      </>
                    ))}
                  {data?.attributes?.Phone_No_2.length > 0 &&
                    data?.attributes?.Phone_No_2.map((phone: any) => (
                      <>
                        <Link
                          href={`tel:${phone}`}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              gap: "0.5rem",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z"
                                  stroke="#666666"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                />
                              </svg>
                            </div>
                            <div style={{ color: "var(--Text-2, #666)" }}>
                              {phone}
                            </div>
                          </div>
                        </Link>
                      </>
                    ))}
                  {data?.attributes?.Email_ID.length > 0 &&
                    data?.attributes?.Email_ID.map((email: any) => (
                      <>
                        <Link
                          href={`mailto:${email}`}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              gap: "0.5rem",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z"
                                  stroke="#666666"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75"
                                  stroke="#666666"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div style={{ color: "var(--Text-2, #666)" }}>
                              {/* nisha.upadhyay@vgos.org */}
                              {email}
                            </div>
                          </div>
                        </Link>
                      </>
                    ))}
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
      {cityData.length > 0 && (
        <div
          style={{
            position: "fixed",
            zIndex: 999999999,
            bottom: "1.25rem",
            right: "1.25rem",
            fontFamily: "Graphik,sans-serif",
            borderRadius: "0.25rem",
            color: "var(--Full-White, #FFF)",
            border: "0.5px solid var(--Text-5, #E0E0E0)",
            fontWeight: "500",
            boxShadow: "0px 4px 20px 0px rgba(123, 127, 222, 0.12)",
            backgroundColor: "var(--Primary, #3F41D1)",
            width: "10rem",
            height: "3.75rem",
            padding: "0.625rem 1.25rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.75rem",
            marginRight: "1rem",
          }}
        >
          <div> Contact Us:</div>
          <div>{"+91 " + cityData?.[0]?.attributes?.Tollfree_No}</div>
        </div>
      )}
    </>
  );
};

export default ContactArea;
